export default __webpack_public_path__ + "static/media/DealingWith2020Stress.87071cb7.pdf";